import React, { useEffect, useState } from "react";
import { ICashTransferClientArchive } from "../../types/archiveCashTClient.type";
import { api } from "../../api/api";
import { DatePicker, message, Table, Typography } from "antd";
import dayjs from "dayjs";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";

const { Title } = Typography;
const { RangePicker } = DatePicker;

export default function ArchiveCashTClients() {
  const [clients, setClients] = useState<ICashTransferClientArchive[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | undefined
  >([dayjs().startOf("month"), dayjs().endOf("month")]);

  const handleRangeChange = (dates: any) => {
    if (dates) {
      setDateRange([dates[0], dates[1]]);
    } else {
      setDateRange(undefined);
    }
  };

  const fetchClients = async () => {
    setLoading(true);

    try {
      const response = await api.get("/archive/cash-transfer-clients", {
        params: {
          page,
          limit: pageSize,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YY") : undefined,
        },
      });

      setClients(response.data.clients);
      setTotal(response.data.total);
    } catch (error) {
      console.error("Error fetching clients", error);
      message.error("Ошибка при получение клиентов.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, [page, pageSize, dateRange]);

  const columns = [
    {
      title: "Дата удаления",
      dataIndex: "dateRemoved",
      key: "dateRemoved",
    },
    {
      title: "Удалил",
      dataIndex: "removedBy",
      key: "removedBy",
    },
    {
      title: "Имя",
      dataIndex: "name",
      key: "name",
      fixed: "left" as "left",
    },
    {
      title: "Долг клиента в USD",
      key: "clientDebtUSD",
      render: (_: any, client: ICashTransferClientArchive) =>
        roundToThreeDecimals(client.totalClientDebt.USD),
    },
    {
      title: "Долг клиента в UZS",
      key: "clientDebtUSD",
      render: (_: any, client: ICashTransferClientArchive) =>
        roundToThreeDecimals(client.totalClientDebt.UZS),
    },
    {
      title: "Наш долг в USD",
      key: "clientDebtUSD",
      render: (_: any, client: ICashTransferClientArchive) =>
        roundToThreeDecimals(client.totalCompanyDebt.USD),
    },
    {
      title: "Наш долг в UZS",
      key: "clientDebtUSD",
      render: (_: any, client: ICashTransferClientArchive) =>
        roundToThreeDecimals(client.totalCompanyDebt.UZS),
    },
    {
      title: "Создал",
      dataIndex: "ownerName",
      key: "ownerName",
    },
  ];
  return (
    <div style={{ padding: 24 }}>
      <Title>Архив Клиентов Обнал</Title>
      <RangePicker
        onChange={handleRangeChange}
        placeholder={["Начало", "Конец"]}
        format="DD.MM.YY"
        value={dateRange}
      />

      <Table
        columns={columns}
        dataSource={clients}
        rowKey={(record) => record._id}
        loading={loading}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
